import type { IConfigArea } from '@d-orca/shared/trusstor';
import type { IInvestigationReportLocation } from '@apis/investigationReports';

export interface IGroupedAreaOption {
  /** `area:<areaId>` or `floor:<floorId>`. */
  selectionKey: string;
  label: string;
  /** Pipe key for grouping (floor id). */
  groupId: string;
  groupLabel: string;
}

export function buildAreaOptions(areas: IConfigArea[]): IGroupedAreaOption[] {
  const byFloor = new Map<string, IConfigArea[]>();
  for (const a of areas) {
    const list = byFloor.get(a.floorId) ?? [];
    list.push(a);
    byFloor.set(a.floorId, list);
  }
  const out: IGroupedAreaOption[] = [];
  for (const [floorId, list] of byFloor) {
    const floorNick = list[0]?.floorNick ?? '';
    if (list.length >= 2) {
      out.push({
        selectionKey: `floor:${floorId}`,
        label: floorNick,
        groupId: floorId,
        groupLabel: floorNick,
      });
    }
    for (const a of list) {
      out.push({
        selectionKey: `area:${a.areaId}`,
        label: a.areaNick,
        groupId: floorId,
        groupLabel: floorNick,
      });
    }
  }
  return out;
}

export function expandSelection(
  selectionKey: string,
  areas: IConfigArea[],
): IInvestigationReportLocation[] {
  if (selectionKey.startsWith('floor:')) {
    const floorId = selectionKey.slice('floor:'.length);
    return areas
      .filter((a) => a.floorId === floorId)
      .map((a) => ({ areaId: a.areaId, areaNick: a.areaNick, floorId: a.floorId, floorNick: a.floorNick }));
  }
  if (selectionKey.startsWith('area:')) {
    const areaId = selectionKey.slice('area:'.length);
    const a = areas.find((x) => x.areaId === areaId);
    return a ? [{ areaId: a.areaId, areaNick: a.areaNick, floorId: a.floorId, floorNick: a.floorNick }] : [];
  }
  return [];
}
